module.exports = __webpack_public_path__ + "static/media/iconLatLng.5d844d36.svg";